import { PureComponent } from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';

export default class TextRow extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
    variables: PropTypes.string.isRequired,
  };

  getValue = (variable) => {
    const {
      data: { textRow },
    } = this.props;
    switch (variable) {
      case 'networkDevicesDiscovered':
        return (textRow.deviceCount || '').toLocaleString();
      case 'networkInterfacesActivetotal':
        return `${(textRow.interfaceActiveCount || '').toLocaleString()} / ${(textRow.interfaceCount || '').toLocaleString()}`;
      case 'numberOfHost':
        return (textRow.userCount || '').toLocaleString();
      case 'interfaceEdgeCount':
        return (textRow.interfaceEdgeCount || '').toLocaleString();
      default:
        return '';
    }
  };

  getRows = () => {
    const { variables, msg } = this.props;
    if (!variables || variables === '') {
      return <div />;
    }
    return (
      <table>
        <tbody>
          {variables.split(',').map((variable) => (
            <tr key={variable} className='dashboard-text-row__tr'>
              <td className='dashboard-text-row__td'>
                {get(msg, ['textRowVariables', variable])}
                <span className='dashboard-text-row__value'>
                  {this.getValue(variable)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    return (
      <div className='center-block dashboard-text-row__wrapper'>
        {this.getRows()}
      </div>
    );
  }
}
